import React, { useState, useEffect } from 'react';

const Countdown = ({ inFullscreen = false, targetDate = "2025-09-20T15:00:00" }) => {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });
    
    const formatDate = () => {
        return "20 Settembre 2025";
    };

    useEffect(() => {
        const updateCountdown = () => {
            const weddingDate = new Date(targetDate);
            const now = new Date();
            const diff = weddingDate - now;

            if (diff > 0) {
                setTimeLeft({
                    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                    minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
                    seconds: Math.floor((diff % (1000 * 60)) / 1000)
                });
            } else {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        };

        updateCountdown();
        const timer = setInterval(updateCountdown, 1000);
        return () => clearInterval(timer);
    }, [targetDate]);
    
    const formattedDate = formatDate();
    
    const addToCalendar = () => {
        const weddingDate = new Date(targetDate);
        const endDate = new Date(weddingDate.getTime() + (5 * 60 * 60 * 1000)); // +5 hours
        
        // Format dates for calendar
        const startISODate = weddingDate.toISOString().replace(/-|:|\.\d+/g, '');
        const endISODate = endDate.toISOString().replace(/-|:|\.\d+/g, '');
        
        // Create Google Calendar URL
        const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=Matrimonio%20Alessandro%20%26%20Ylenia&dates=${startISODate}/${endISODate}&details=Siamo%20felici%20di%20invitarti%20al%20nostro%20matrimonio!&location=Chiesa%20Santa%20Maria%20di%20Custonaci,%20Custonaci,%20TP`;
        
        // Open in new tab
        window.open(googleCalendarUrl, '_blank');
    };

    // Render the new circular countdown with separate images for each element
    const renderCircularCountdown = () => {
        return (
            <div className="circular-countdown">
                <div className="countdown-circles">
                    <div className="countdown-circle-item">
                        <div className="countdown-circle-container">
                            <img src="/assets/img/countdown.svg" alt="Days" className="countdown-circle-img" />
                            <div className="countdown-circle-content">
                                <div className="countdown-value font">{String(timeLeft.days).padStart(2, '0')}</div>
                                <div className="countdown-unit font uppercase">Giorni</div>
                            </div>
                        </div>
                    </div>
                    <div className="countdown-circle-item">
                        <div className="countdown-circle-container">
                            <img src="/assets/img/countdown.svg" alt="Hours" className="countdown-circle-img" />
                            <div className="countdown-circle-content">
                                <div className="countdown-value font">{String(timeLeft.hours).padStart(2, '0')}</div>
                                <div className="countdown-unit font uppercase">Ore</div>
                            </div>
                        </div>
                    </div>
                    <div className="countdown-circle-item">
                        <div className="countdown-circle-container">
                            <img src="/assets/img/countdown.svg" alt="Minutes" className="countdown-circle-img" />
                            <div className="countdown-circle-content">
                                <div className="countdown-value font">{String(timeLeft.minutes).padStart(2, '0')}</div>
                                <div className="countdown-unit font uppercase">Min</div>
                            </div>
                        </div>
                    </div>
                    <div className="countdown-circle-item">
                        <div className="countdown-circle-container">
                            <img src="/assets/img/countdown.svg" alt="Seconds" className="countdown-circle-img" />
                            <div className="countdown-circle-content">
                                <div className="countdown-value font">{String(timeLeft.seconds).padStart(2, '0')}</div>
                                <div className="countdown-unit font uppercase">Sec</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    
    return (
        <div className="countdown-wrapper">
            <div className="wedding-date font uppercase">
                {formattedDate}
            </div>
            
            {renderCircularCountdown()}
            
            <div className="calendar-button-container">
                <button 
                    className="calendar-button font"
                    onClick={addToCalendar}
                    title="Salva la data nel tuo calendario"
                >
                    <span className="calendar-icon">🗓️</span> Salva la data
                </button>
            </div>
        </div>
    );
};

export default Countdown;